import { avoidBreakInside } from '@provider/print';
import { selectableCharacterInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useInputState } from '../../hook.use-input-state.js';
import { StateBox } from '../atom.state-box/_state-box.js';
import { stateBox, button } from './input.character.style.js';
import { jsx } from 'react/jsx-runtime';

function CharacterInput(props) {
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => selectableCharacterInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, props.node.id, {
      type: "selectable-character",
      selected: !inputEntry?.selected
    });
  };
  const state = useInputState(props.node, inputEntry);
  if (state === "correct" || state === "incorrect") {
    const boxState = state === "incorrect" && props.node.validation.shouldBeMarked ? "should-have" : state;
    return /*#__PURE__*/jsx(StateBox, {
      state: boxState,
      textTheme: "colored",
      className: stateBox,
      children: props.node.character
    });
  }
  if (state === "readonly") {
    return /*#__PURE__*/jsx("span", {
      className: button,
      "data-selected": inputEntry?.selected,
      ...avoidBreakInside(),
      children: props.node.character
    });
  }
  return /*#__PURE__*/jsx("button", {
    className: button,
    onClick: onChange,
    "data-selected": inputEntry?.selected,
    ...avoidBreakInside(),
    children: props.node.character
  });
}

export { CharacterInput };
//# sourceMappingURL=input.character.js.map
